import React, { createContext, useContext, useState, useCallback } from "react";
import ConfirmModal from "../components/ui/ConfirmModal";

const ConfirmContext = createContext(null);

export const ConfirmProvider = ({ children }) => {
    const [state, setState] = useState(null);

    const confirm = useCallback(({ title, message, confirmLabel, cancelLabel, variant }) => {
        return new Promise((resolve) => {
            if (state) state.resolve(false);
            setState({ title, message, confirmLabel, cancelLabel, variant, resolve });
        });
    }, [state]);

    const handleConfirm = () => {
        state?.resolve(true);
        setState(null);
    };

    const handleCancel = () => {
        state?.resolve(false);
        setState(null);
    };

    return (
        <ConfirmContext.Provider value={confirm}>
            {children}
            {state && (
                <ConfirmModal
                    title={state.title}
                    message={state.message}
                    confirmLabel={state.confirmLabel}
                    cancelLabel={state.cancelLabel}
                    variant={state.variant}
                    onConfirm={handleConfirm}
                    onCancel={handleCancel}
                />
            )}
        </ConfirmContext.Provider>
    );
};

export const useConfirm = () => {
    const ctx = useContext(ConfirmContext);
    if (!ctx) throw new Error("useConfirm must be used within a ConfirmProvider");
    return ctx;
};
